export { default } from './InputComponent';
